import { isJSONTreatment, useFeatureFlag } from '@moda/portal-stanchions';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

enum Devices {
  Mobile = 'mobile',
  Desktop = 'desktop'
}

type VisualStyleFeatureFlag =
  | Record<string, Record<string, Devices[] | null> | null>
  | null
  | Record<string, never>;

export const useVisualStyleFiltersFeatureFlag = () => {
  const { category, subcategory } = useParams<{
    category: string | undefined;
    subcategory: string | undefined;
  }>();

  const treatment = useFeatureFlag<VisualStyleFeatureFlag>('visual-style-filters', [
    {
      default: {}
    },
    {
      getFromTreatment: treatment =>
        isJSONTreatment(treatment) ? (treatment as VisualStyleFeatureFlag) : {}
    }
  ]);

  const path = useMemo(() => {
    if (!category) {
      return undefined;
    }

    if (!subcategory) {
      return `/visual_style_filters/${category}`;
    }

    return `/visual_style_filters/${category}/${subcategory}`;
  }, [category, subcategory]);

  const isEnabled = useMemo(() => {
    if (!treatment) {
      return null;
    }

    if (!category) {
      return null;
    }

    if (!subcategory) {
      return {
        mobile: treatment[category]?.__default?.find(_ => _ === Devices.Mobile),
        desktop: treatment[category]?.__default?.find(_ => _ === Devices.Desktop)
      };
    }

    return {
      mobile: treatment[category]?.[subcategory]?.find(_ => _ === Devices.Mobile),
      desktop: treatment[category]?.[subcategory]?.find(_ => _ === Devices.Desktop)
    };
  }, [category, subcategory, treatment]);

  return {
    isDesktopEnabled: Boolean(isEnabled?.desktop),
    isMobileEnabled: Boolean(isEnabled?.mobile),
    path
  };
};
